import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpinner = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 31,
	height: 30,
	viewBox: "0 0 31 30",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 14.7085,
			width: 1.25,
			height: 7.5,
			rx: .625,
			fill: "#C4C4C4"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .333496,
			y: 15.625,
			width: 1.25,
			height: 7.5,
			rx: .625,
			transform: "rotate(-90 0.333496 15.625)",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8.37451,
			y: 28.3029,
			width: 1.25,
			height: 7.5,
			rx: .625,
			transform: "rotate(-150 8.37451 28.3029)",
			fill: "#2B2B2B"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 23.3745,
			y: 27.6779,
			width: 1.25,
			height: 7.5,
			rx: .625,
			transform: "rotate(150 23.3745 27.6779)",
			fill: "#575757"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 28.6362,
			y: 21.9587,
			width: 1.25,
			height: 7.5,
			rx: .625,
			transform: "rotate(120 28.6362 21.9587)",
			fill: "#6D6D6D"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 28.0112,
			y: 6.95874,
			width: 1.25,
			height: 7.5,
			rx: .625,
			transform: "rotate(60 28.0112 6.95874)",
			fill: "#989898"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 15.9585,
			y: 30,
			width: 1.25,
			height: 7.5,
			rx: .625,
			transform: "rotate(180 15.9585 30)",
			fill: "#414141"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 30.3335,
			y: 14.375,
			width: 1.25,
			height: 7.5,
			rx: .625,
			transform: "rotate(90 30.3335 14.375)",
			fill: "#828282"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 22.2925,
			y: 1.69714,
			width: 1.25,
			height: 7.5,
			rx: .625,
			transform: "rotate(30 22.2925 1.69714)",
			fill: "#AEAEAE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7.29248,
			y: 2.32214,
			width: 1.25,
			height: 7.5,
			rx: .625,
			transform: "rotate(-30 7.29248 2.32214)",
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2.03076,
			y: 8.04126,
			width: 1.25,
			height: 7.5,
			rx: .625,
			transform: "rotate(-60 2.03076 8.04126)",
			fill: "#EFEFEF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2.65576,
			y: 23.0413,
			width: 1.25,
			height: 7.5,
			rx: .625,
			transform: "rotate(-120 2.65576 23.0413)",
			fill: "#161616"
		})
	]
});
export default SvgSpinner;
